import { render, staticRenderFns } from "./RemoveGaauButton.vue?vue&type=template&id=1914f852&"
import script from "./RemoveGaauButton.vue?vue&type=script&lang=js&"
export * from "./RemoveGaauButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports